import React from "react";

import IconHide from "../RouteChart/IconHide";
import IconLock from "../RouteChart/IconLock";
import { getTranslation } from "../../utils/helper";

const DriverHeader = ({ driverIdsLock, driverIdsHide, onClickLock, onClickHide, setting }) => {
  const isLock = driverIdsLock.includes("all-drivers");
  const isHide = driverIdsHide.includes("all-drivers");

  return (
    <div className="tr" style={{ width: "100%" }}>
      <div className="td">
        <div className="driver-name all-drivers">
          <IconLock isLock={isLock} onClickLock={() => onClickLock("all-drivers")} />
          <IconHide isHide={isHide} onClickHide={() => onClickHide("all-drivers")} />
          <b>{getTranslation(setting, "Route Plans", "Drivers")}</b>
        </div>
      </div>
      <div
        className="td items"
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}>
        <div className="item" style={{ width: "100px" }}></div>
        <div className="item" style={{ width: "20%" }}>
          {getTranslation(setting, "Route Plans", "# of Stops")}
        </div>
        <div className="item" style={{ width: "25%" }}>
          {getTranslation(setting, "Route Plans", "Phone Number")}
        </div>
        <div className="item" style={{ width: "30%" }}>
          {getTranslation(setting, "Route Plans", "Route URL")}
        </div>
        <div className="item" style={{ width: "25%" }}>
          {getTranslation(setting, "Route Plans", "Last Update")}
        </div>
      </div>
    </div>
  );
};

export default DriverHeader;
